<input
  #scanInput
  type="text"
  [(ngModel)]="scanInputText"
  class="scan-clearance-input"
  (input)="onInput($event.target.value)"
  (keyup.enter)="onEnter($event.target.value)"
  [disabled]="isReadOnly"
  pInputText
/>

<div *ngIf="isReadOnly" class="readonly-message">
  {{ 'SIGNATURE.READONLY_MESSAGE' | translate }}
</div>

<div class="p-grid">
  <div class="p-col" *ngIf="fields$ | async as fields">
    <p class="scan-warning-text" *ngIf="isCapsLockOn">{{ 'SETUP_LINE_CLEARANCE.CAPSLOCK_ON_WARNING' | translate }}</p>
    <app-line-clearance-list-in-setup
      [fields]="fields"
      [hasFocus]="lineClearanceListHasFocus"
      [disabled]="isReadOnly"
      (formValid)="onFormValidityChange($event)"
    ></app-line-clearance-list-in-setup>
  </div>
</div>

<div *ngIf="shouldShowSignatureContainer()" class="signature-container">
  <app-signature
      #leftSignature
      [ngClass]="getSignatureClasses('left-signature')"
      [productionQaCheck]="leftSignatureQaChecks"
      [requireEmployeeRegistration]="true"
      [signatureConfig]="signatureConfig"
      [employeeSuggestions]="false"
      [disabled]="isReadOnly"
      (click)="setActiveSignature('left-signature')"
      (qaSignatureScan)="onQaSignatureScanned($event)">
  </app-signature>
  <app-signature
      #rightSignature
      [ngClass]="getSignatureClasses('right-signature')"
      [productionQaCheck]="rightSignatureQaChecks"
      [requireEmployeeRegistration]="false"
      [signatureConfig]="signatureConfig"
      [employeeSuggestions]="false"
      [disabled]="isReadOnly"
      (click)="setActiveSignature('right-signature')"
      (qaSignatureScan)="onQaSignatureScanned($event)">
  </app-signature>
</div>
